/**
 * Product Card Mobile Slider
 * Mobile-only image slider with arrow navigation
 * Uses Swiper.js for functionality
 */

if (typeof MinimogLibs === 'undefined' || typeof MinimogLibs.Swiper === 'undefined') {
    console.warn('MinimogLibs.Swiper not available. Mobile slider will not initialize.');
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initMobileProductCardSlider();
    });
}

function initMobileProductCardSlider() {
    // Check if we're on mobile viewport
    const isMobile = () => window.innerWidth <= 767;

    // Store swiper instances
    const swiperInstances = new Map();

    // Initialize slider for a specific product card
    function initSlider(container) {
        const swiperContainer = container.querySelector('.swiper-container');

        if (!swiperContainer) return;

        // Check if already initialized
        if (swiperInstances.has(swiperContainer)) return;

        // Fix all images IMMEDIATELY and SYNCHRONOUSLY before any checks
        const allImages = swiperContainer.querySelectorAll('img');
        allImages.forEach(img => {
            const responsiveEl = img.closest('responsive-image');

            // Get the theme's aspect ratio from CSS variable
            let aspectRatio = 0.75; // Default 3:4
            if (responsiveEl && responsiveEl.style.getPropertyValue('--aspect-ratio')) {
                const ratioStr = responsiveEl.style.getPropertyValue('--aspect-ratio');
                const [w, h] = ratioStr.split('/').map(v => parseFloat(v.trim()));
                if (!isNaN(w) && !isNaN(h) && h > 0) {
                    aspectRatio = w / h;
                }
            }

            // Immediately set correct attributes BEFORE responsive-image component can run
            img.setAttribute('width', '1100');
            img.setAttribute('height', Math.round(1100 * aspectRatio));
            img.setAttribute('sizes', '(min-width: 1280px) 287px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)');

            // Mark as loaded so CSS shows it - DO THIS FIRST!
            img.setAttribute('data-loaded', 'true');
        });

        const slides = swiperContainer.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) {
            // Hide navigation if only one slide
            const prevBtn = container.querySelector('.m-product-card__slider-nav--prev');
            const nextBtn = container.querySelector('.m-product-card__slider-nav--next');
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
            return;
        }

        // Get navigation buttons
        const nextButton = container.querySelector('.m-product-card__slider-nav--next');
        const prevButton = container.querySelector('.m-product-card__slider-nav--prev');

        // Initialize Swiper with proper configuration
        const swiper = new MinimogLibs.Swiper(swiperContainer, {
            init: true,
            direction: 'horizontal',
            loop: false,
            speed: 300,
            effect: 'slide',
            spaceBetween: 0,
            slidesPerView: 1,
            centeredSlides: true,
            // Disable swipe/touch - use arrow buttons only
            allowTouchMove: false,
            simulateTouch: false,
            noSwiping: true,
            preventInteractionOnTransition: false,
            // Don't set width manually - let it calculate from container
            autoHeight: false,
            roundLengths: true,
            // Observer settings
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },
            on: {
                init: function () {
                    console.log('Swiper initialized for container:', swiperContainer);
                    // Set initial navigation state
                    updateNavigationState(this);
                    // Handle first slide video
                    handleSlideVideos(this);
                    // Show arrows with fade-in transition (matches image transition)
                    const navButtons = container.querySelectorAll('.m-product-card__slider-nav');
                    navButtons.forEach(btn => {
                        btn.classList.add('m-product-card__slider-nav--visible');
                    });
                },
                slideChange: function () {
                    console.log('Slide changed to index:', this.activeIndex);
                    // Update navigation state on slide change
                    updateNavigationState(this);
                    // Handle video playback on slide change
                    handleSlideVideos(this);
                }
            }
        });

        console.log('Swiper instance created:', swiper);

        // Manual navigation handlers
        if (nextButton) {
            nextButton.addEventListener('click', (e) => {
                // Stop event propagation immediately to prevent clicks from passing through
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                // Block clicks on disabled buttons - keeps same appearance but no action
                if (nextButton.classList.contains('m-product-card__slider-nav--disabled') || nextButton.disabled) {
                    return;
                }

                console.log('Next button clicked');
                if (swiper && !swiper.destroyed) {
                    swiper.slideNext();
                }
            });
        }

        if (prevButton) {
            prevButton.addEventListener('click', (e) => {
                // Stop event propagation immediately to prevent clicks from passing through
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                // Block clicks on disabled buttons - keeps same appearance but no action
                if (prevButton.classList.contains('m-product-card__slider-nav--disabled') || prevButton.disabled) {
                    return;
                }

                console.log('Previous button clicked');
                if (swiper && !swiper.destroyed) {
                    swiper.slidePrev();
                }
            });
        }

        // Store instance
        swiperInstances.set(swiperContainer, swiper);

        // Watch for attribute changes from responsive-image component
        const imageObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' &&
                    (mutation.attributeName === 'sizes' || mutation.attributeName === 'width' || mutation.attributeName === 'height')) {
                    const img = mutation.target;
                    const responsiveEl = img.closest('responsive-image');

                    // Get the theme's aspect ratio from CSS variable
                    let aspectRatio = 0.75; // Default 3:4
                    if (responsiveEl && responsiveEl.style.getPropertyValue('--aspect-ratio')) {
                        const ratioStr = responsiveEl.style.getPropertyValue('--aspect-ratio');
                        const [w, h] = ratioStr.split('/').map(v => parseFloat(v.trim()));
                        if (!isNaN(w) && !isNaN(h) && h > 0) {
                            aspectRatio = w / h;
                        }
                    }

                    // Fix if responsive-image component sets wrong values
                    const needsFix = (img.sizes && (img.sizes.includes('838') || img.sizes.includes('1672') || parseInt(img.sizes) > 2000)) ||
                        img.width > 1100 ||
                        img.height > 1500;

                    if (needsFix) {
                        img.setAttribute('width', '1100');
                        img.setAttribute('height', Math.round(1100 * aspectRatio));
                        img.setAttribute('sizes', '(min-width: 1280px) 287px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)');
                        img.setAttribute('data-loaded', 'true');
                    }
                }
            });
        });

        // Observe all images in the slider
        const imagesToObserve = swiperContainer.querySelectorAll('img');
        imagesToObserve.forEach(img => {
            imageObserver.observe(img, { attributes: true });
        });

        // Store observer for cleanup
        swiper.imageObserver = imageObserver;

        // Also run a delayed fix to catch any late modifications
        setTimeout(() => {
            const images = swiperContainer.querySelectorAll('img');
            images.forEach(img => {
                const responsiveEl = img.closest('responsive-image');

                // Get the theme's aspect ratio from CSS variable
                let aspectRatio = 0.75; // Default 3:4
                if (responsiveEl && responsiveEl.style.getPropertyValue('--aspect-ratio')) {
                    const ratioStr = responsiveEl.style.getPropertyValue('--aspect-ratio');
                    const [w, h] = ratioStr.split('/').map(v => parseFloat(v.trim()));
                    if (!isNaN(w) && !isNaN(h) && h > 0) {
                        aspectRatio = w / h;
                    }
                }

                const needsFix = img.width > 1100 || img.height > 1500 || (img.sizes && parseInt(img.sizes) > 2000);

                if (needsFix) {
                    img.setAttribute('width', '1100');
                    img.setAttribute('height', Math.round(1100 * aspectRatio));
                    img.setAttribute('sizes', '(min-width: 1280px) 287px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)');
                    img.setAttribute('data-loaded', 'true');
                }
            });
            // Update swiper size after fixing images
            if (swiper && !swiper.destroyed) {
                swiper.update();
            }
        }, 100);

        return swiper;
    }

    // Update navigation button states based on current slide position
    function updateNavigationState(swiper) {
        const container = swiper.el.closest('.m-product-card__slider-mobile');
        const prevButton = container.querySelector('.m-product-card__slider-nav--prev');
        const nextButton = container.querySelector('.m-product-card__slider-nav--next');

        // Disable prev button on first slide
        if (swiper.isBeginning) {
            prevButton.classList.add('m-product-card__slider-nav--disabled');
            prevButton.disabled = true;
        } else {
            prevButton.classList.remove('m-product-card__slider-nav--disabled');
            prevButton.disabled = false;
        }

        // Disable next button on last slide
        if (swiper.isEnd) {
            nextButton.classList.add('m-product-card__slider-nav--disabled');
            nextButton.disabled = true;
        } else {
            nextButton.classList.remove('m-product-card__slider-nav--disabled');
            nextButton.disabled = false;
        }
    }

    // Handle video playback for slides
    function handleSlideVideos(swiper) {
        const activeIndex = swiper.activeIndex;
        const slides = swiper.slides;

        slides.forEach((slide, index) => {
            const videoElement = slide.querySelector('video');
            const isActive = index === activeIndex;

            if (videoElement) {
                if (isActive) {
                    // Play active video
                    if (videoElement.paused || videoElement.ended) {
                        videoElement.play().catch(error => {
                            // Autoplay might be blocked, that's okay
                            console.log('Video autoplay prevented:', error);
                        });
                    }
                } else {
                    // Pause non-active videos
                    if (!videoElement.paused) {
                        videoElement.pause();
                    }
                }
            }
        });
    }

    // Destroy slider for a specific container
    function destroySlider(container) {
        const swiperContainer = container.querySelector('.swiper-container');

        if (swiperInstances.has(swiperContainer)) {
            const swiper = swiperInstances.get(swiperContainer);
            // Disconnect image observer if exists
            if (swiper.imageObserver) {
                swiper.imageObserver.disconnect();
            }
            swiper.destroy(true, true);
            swiperInstances.delete(swiperContainer);
            container.classList.remove('m-product-card__slider-initialized');
        }
    }

    // Initialize all sliders on the page
    function initAllSliders() {
        // Check if mobile slider is enabled via theme setting
        const bodyElement = document.body;
        const sliderEnabled = bodyElement && bodyElement.dataset.sliderEnabled === 'true';

        if (!isMobile() || !sliderEnabled) {
            // Destroy all sliders on desktop or if disabled
            document.querySelectorAll('.m-product-card__slider-mobile').forEach(destroySlider);
            return;
        }

        // Initialize sliders on mobile if enabled
        document.querySelectorAll('.m-product-card__slider-mobile').forEach(container => {
            initSlider(container);
        });
    }

    // Handle viewport changes
    let resizeTimeout;
    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            initAllSliders();
        }, 250);
    }

    // Add resize listener
    window.addEventListener('resize', handleResize);

    // Handle visibility changes for performance - only affect product card sliders
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            // Pause all product card slider videos when tab is hidden
            document.querySelectorAll('.m-product-card__slider-mobile .swiper-slide video').forEach(video => {
                if (!video.paused) {
                    video.pause();
                    video.dataset.wasPlaying = 'true';
                }
            });
        } else {
            // Resume product card slider videos that were playing
            document.querySelectorAll('.m-product-card__slider-mobile .swiper-slide video').forEach(video => {
                if (video.dataset.wasPlaying === 'true') {
                    video.play().catch(() => { });
                    delete video.dataset.wasPlaying;
                }
            });
        }
    });

    // Initial initialization
    initAllSliders();

    // Re-initialize when new product cards are loaded (AJAX, filtering, etc.)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                // Check if new product cards were added
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                        const newSliders = node.querySelectorAll ?
                            node.querySelectorAll('.m-product-card__slider-mobile') : [];

                        newSliders.forEach(container => {
                            if (isMobile()) {
                                initSlider(container);
                            }
                        });
                    }
                });
            }

            // Check if slider containers became visible (product tabs)
            const sliders = document.querySelectorAll('.m-product-card__slider-mobile');
            sliders.forEach(container => {
                if (isMobile() && container.offsetParent !== null) {
                    // Container is visible, update navigation state
                    const swiperContainer = container.querySelector('.swiper-container');
                    if (swiperInstances.has(swiperContainer)) {
                        const swiper = swiperInstances.get(swiperContainer);
                        if (swiper && !swiper.destroyed) {
                            updateNavigationState(swiper);
                        }
                    }
                }
            });
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Expose function globally for manual initialization if needed
    window.MinimogProductCardSlider = {
        init: initSlider,
        destroy: destroySlider,
        initAll: initAllSliders,
        destroyAll: () => {
            document.querySelectorAll('.m-product-card__slider-mobile').forEach(destroySlider);
            observer.disconnect();
        }
    };
}